import axios from '@/config/api.request'
const token = localStorage.getItem("untrading-token");

export default {
    // 是否喜欢
    liked(cryptoId) {
        if(!token) {
            return { data: { success: false } }
        }
        return axios.request({
            url: '/crypto/like/liked',
            method: 'get',
            params: { cryptoId }
        })
    },
    // 喜欢
    like(cryptoId) {
        return axios.request({
            url: '/crypto/like/like',
            method: 'get',
            params: { cryptoId }
        })
    },
    // 取消喜欢
    unlike(cryptoId) {
        return axios.request({
            url: '/crypto/like/unlike',
            method: 'get',
            params: { cryptoId }
        })
    },
    
}